<div [class.opacity-50]="disabled" class="flex gap-3">
  <div class="flex h-6 shrink-0 items-center">
    <div class="group grid size-4 grid-cols-1">
      <input (ngModelChange)="checkedChange.emit($event)" [disabled]="disabled" [id]="id" [ngModel]="checked"
             aria-describedby="comments-description"
             class="col-start-1 row-start-1 appearance-none rounded border border-gray-300 bg-white checked:!border-theme-primary-700 checked:!bg-theme-primary-700 indeterminate:!border-theme-primary-700 indeterminate:!bg-theme-primary-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-theme-primary-700 disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
             name="comments"
             type="checkbox">
      <svg
        class="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-[:disabled]:stroke-gray-950/25"
        fill="none" viewBox="0 0 14 14">
        <path class="opacity-0 group-has-[:checked]:!opacity-100" d="M3 8L6 11L11 3.5" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
        <path class="opacity-0 group-has-[:indeterminate]:!opacity-100" d="M3 7H11" stroke-linecap="round"
              stroke-linejoin="round" stroke-width="2"/>
      </svg>
    </div>
  </div>
  <div class="text-sm/6">
    <label [class.text-gray-50]="disabled" [for]="id" class="font-medium text-gray-900">{{ label }}</label>
  </div>
</div>
